import axios from "axios";
import { urlCoreBack } from "../configs/config";
import "../utils/axios.interceptor";
import { format } from "date-fns";

const epName = "v1/fornitura-valor/";
const nameItemsText = "Valores de Fornituras";
const nameItemText = "Valor de Fornitura";
const itemGender = "F";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";
//
// #############################################################################
//
export const getForniturasValor = async (params) => {
  let _params = {};
  let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

  if (params.tipo_busqueda === "ingresoArticulo") {
    _params = {
      tipo_busqueda: "ingreso-articulo",
      codigo: params.codigo,
    };
  } else {
    _params.tipo_busqueda = "articulo";

    if (params) {
      if (params.codigo) {
        _params.codigo = params.codigo;
      }

      if (params.codigoExterno) {
        _params.codigo_externo = params.codigoExterno;
      }

      if (params.descripcion) {
        _params.descripcion = params.descripcion;
      }

      if (params.estado) {
        let estado =
          params.estado === "habilitado"
            ? "H"
            : params.estado === "deshabilitado"
              ? "D"
              : "";
        _params.habilitado = estado;
      }

      if (params.desdeCostoUltimo) {
        _params.ultimo_costo_desde = params.desdeCostoUltimo;
      }

      if (params.hastaCostoUltimo) {
        _params.ultimo_costo_hasta = params.hastaCostoUltimo;
      }

      if (params.fechaDesdeCostoUltimo) {
        _params.fecha_ultimo_costo_desde = format(
          params.fechaDesdeCostoUltimo,
          "yyyy/MM/dd",
        );
      }

      if (params.fechaHastaCostoUltimo) {
        _params.fecha_ultimo_costo_hasta = format(
          params.fechaHastaCostoUltimo,
          "yyyy/MM/dd",
        );
      }

      if (params.desdeCostoActual) {
        _params.actual_costo_desde = params.desdeCostoActual;
      }

      if (params.hastaCostoActual) {
        _params.actual_costo_hasta = params.hastaCostoActual;
      }

      if (params.fechaDesdeCostoActual) {
        _params.fecha_actual_costo_desde = format(
          params.fechaDesdeCostoActual,
          "yyyy/MM/dd",
        );
      }

      if (params.fechaHastaCostoActual) {
        _params.fecha_actual_costo_hasta = format(
          params.fechaHastaCostoActual,
          "yyyy/MM/dd",
        );
      }
    }
  }

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error =
        "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }

      if (
        response.data.code === "err-fornitura-valor-ingreso-articulo-not-exist"
      ) {
        response.ok = false;
        response.messageText =
          "No existe un Ingreso de Articulo con el código ingresado";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getFornituraValor = async (params) => {
  let _errorMessage = `Se produjo un error al obtener ${nameItemsText}`;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epName}`,
      params: params,
    });

    if (response.status === 200) {
      let _error =
        "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};

//
// #############################################################################
//
export const saveFornituraValor = async (items) => {
  let _errorMessage = `No fue posible guardar ${elLa} ${nameItemText}`;
  try {
    const response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epName}`,
      data: {
        fornitura_list: items,
      },
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Valores actualizados";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;

  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
